import JSONApiClient from '../jsonapi-service';

export function createComment(commentData) {

  const client = JSONApiClient();

  const comment = client.create('comments');

  comment.set('comment', commentData.comment);
  if (commentData.documentId) comment.set('document', { type: 'documents', id: commentData.documentId });
  if (commentData.commentType) comment.set('commentType', commentData.commentType);
  comment.set('deliverable', { type: 'deliverables', id: commentData.deliverableId });
  comment.set('user', { type: 'users', id: commentData.userId });

  return comment.sync()
    .then(response => {
      // Returns a resource not a JSON object
      return response;
    });
}



/** WEBPACK FOOTER **
 ** ./src/utils/jsonapi-functions/comments.js
 **/